import React from "react";

const Footer: React.FC = () => {
  return (
    <footer className="relative bg-black text-white overflow-hidden">
      {/* Imagen de fondo con lazy loading */}
      <div className="absolute inset-0 z-0 ml-0 md:ml-52">
        <img
          src={
            "https://res.cloudinary.com/xvzxvfee/image/upload/v1788743200/fondo_kk4tqb.webp"
          }
          alt=""
          loading="lazy"
          decoding="async"
          className="h-full w-full object-cover object-center"
          aria-hidden="true"
        />
      </div>

      {/* Overlay con degradado */}
      <div className="absolute inset-0 bg-gradient-to-b from-black to-transparent z-1"></div>

      <div className="relative z-10 max-w-[110rem] mx-auto px-5 md:px-6 lg:px-20 pt-10 md:pt-16 pb-8 md:pb-10">
        {/* Contenido principal */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {/* Columna izquierda */}
          <div className="space-y-4 md:space-y-6 text-center md:text-left">
            <h3 className="text-base md:text-lg font-bold bg-gradient-to-r from-prin3/80 via-gold to-prin1 bg-clip-text text-transparent">
              Tecnología creada para hacer crecer tus ideas
            </h3>

            <p className="text-gray-300 text-sm md:text-base leading-relaxed max-w-none md:max-w-xs mx-auto md:mx-0">
              Si te apasiona la tecnología, síguenos en nuestras redes y
              descubre ideas, proyectos y contenido sobre el mundo digital.
            </p>

            {/* Iconos */}
            <div className="flex justify-center md:justify-start space-x-4">
              {/* Facebook */}
              <a
                href="https://www.facebook.com/profile.php?id=100095027568458"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="w-6 h-6 rounded-sm bg-gradient-to-br from-[#D08E00] to-[#6A4800] flex items-center justify-center"
              >
                <i className="fa-brands fa-facebook-f text-black text-lg" />
              </a>

              {/* Instagram */}
              <a
                href="https://instagram.com/sprintcore/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-6 h-6 rounded-sm bg-gradient-to-br from-[#D08E00] to-[#6A4800] flex items-center justify-center"
              >
                <i className="fa-brands fa-instagram text-black text-lg" />
              </a>

              {/* LinkedIn */}
              <a
                href="https://www.linkedin.com/company/sprintcore"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="w-6 h-6 rounded-sm bg-gradient-to-br from-[#D08E00] to-[#6A4800] flex items-center justify-center"
              >
                <i className="fa-brands fa-linkedin-in text-black text-lg" />
              </a>
            </div>
          </div>

          {/* Columna central (ahora son botones que navegan a secciones) */}
          <div className="space-y-2 md:space-y-3 text-center">
            {[
              { name: "Inicio", path: "#hero" },
              { name: "Servicios", path: "#services" },
              { name: "Proyectos", path: "#proyects" },
              { name: "Sobre Nosotros", path: "#about" },
              { name: "Preguntas Frecuentes", path: "#questions" },
            ].map((item) => (
              <button
                key={item.path}
                type="button"
                onClick={() => {
                  const el = document.querySelector(item.path);
                  if (el) el.scrollIntoView({ behavior: "smooth" });
                }}
                className="block w-full tracking-widest text-center text-white bg-none border-0 p-0 m-0 cursor-pointer transition-all duration-300 ease-out hover:text-gold"
                style={{ backgroundColor: "transparent" }}
              >
                {item.name}
              </button>
            ))}
          </div>

          {/* Columna derecha */}
          <div className="space-y-3 md:space-y-4 text-center md:text-right">
            <h3 className="font-bold text-lg md:text-xl bg-gradient-to-r from-prin2 via-gold to-prin3 bg-clip-text text-transparent tracking-[4px] md:tracking-[5px]">
              +593 95 921 8750
            </h3>
            <h3 className="font-bold text-lg bg-gradient-to-r text-white bg-clip-text text-transparent tracking-[4px] md:tracking-[5px]">
              soporte@sprintcore.ec
            </h3>
            <div className="h-[1px] bg-gray-200/30"></div>
            <p className="text-gray-300 text-sm md:text-base leading-relaxed">
              Hablemos de tu proyecto. Nosotros te ayudamos a darle forma.
            </p>
          </div>
        </div>

        <div className="mt-10 md:mt-28 flex flex-col md:flex-row items-center justify-between space-y-3 md:space-y-0">
          <p className="text-sm md:text-md tracking-widest text-center text-white">
            SprintCore — Innovando el futuro
          </p>
          <div className="flex items-center space-x-3 ml-0 md:ml-24">
            <img
              loading="lazy"
              decoding="async"
              src={
                "https://res.cloudinary.com/xvzxvfee/image/upload/v1788743202/sc_qynokn.webp"
              }
              alt="Sprint Core"
              className="h-7 md:h-8 w-auto"
            />
          </div>

          <p className="text-xs md:text-sm text-gray-400 mr-6">
            © 2026 SprintCore. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
